import { render } from "./ServizioExtra.vue?vue&type=template&id=7ba77603"
import script from "./ServizioExtra.vue?vue&type=script&lang=js"
export * from "./ServizioExtra.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__